@if (entry?.base?.display) {
  <div>
    <h3>{{ entry.base?.text }}</h3>
    <!-- During enrollment flow we need to show a checkbox to confirm receipt -->
    @if (!reviewOnly) {
      <ptl-entry-as-json [entryConfig]="subEntry" [form]="parentForm" [formConfig]="formConfig"></ptl-entry-as-json>
    }
    <ptl-entry-as-json [entryConfig]="sendEmailEntry" [form]="parentForm" [formConfig]="formConfig" [reviewOnly]="true"></ptl-entry-as-json>
  </div>
}